import Modbus from "./modbus.js";

const REG_BHT_MODEL_NUMBER = 0xF110;
const REG_SERIAL_NUMBER = 0xF118;
const REG_MEASURED_VALUE = 0x20;
const REG_SETPOINT = 0x21;
const REG_ALARM_INFO = 0x0034;
const REG_TEMPERATURE = 0xA138;
const REG_COUNTER_VALUE = 0x0D01;
const REG_WINK = 0x0000;


const REG_FLUID_NAME = 0x8188;


class IQFlow extends Modbus {
  constructor(...args) {
    super(...args);
  }
  async getBHTModelNumber() {
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_BHT_MODEL_NUMBER, 12);
    var uint8Array = new Uint8Array(arrayBuffer);

    /* does not follow modbus standard so we have to swap bytes */
    for (var i=0, holder; i<uint8Array.length; i+=2) {
      holder = uint8Array[i];
      uint8Array[i] = uint8Array[i+1];
      uint8Array[i+1] = holder;
    }

    var string = new TextDecoder().decode(uint8Array);
    return(string);
  }
  async getSerialNumber() {
    /* after the 5th register it reads garbage */
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_SERIAL_NUMBER, 5);
    var uint8Array = new Uint8Array(arrayBuffer);
	
    /* does not follow modbus standard so we have to swap bytes */
    for (var i=0, holder; i<uint8Array.length; i+=2) {
      holder = uint8Array[i];
      uint8Array[i] = uint8Array[i+1];
      uint8Array[i+1] = holder;
    }

    var string = new TextDecoder().decode(uint8Array);
    return(string);
  }  
  async getMeasuredValue() {
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_MEASURED_VALUE, 1);
    var dataView = new DataView(arrayBuffer);    
    return dataView.getUint16(0, true);
  }
  async getCounterValue() {
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_COUNTER_VALUE, 1);
    var dataView = new DataView(arrayBuffer);    
    return dataView.getUint16(0, true);
  }  
  async getSelectedFluidName() {
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_FLUID_NAME, 5);
    var uint8Array = new Uint8Array(arrayBuffer);

    /* does not follow modbus standard so we have to swap bytes */
    for (var i=0, holder; i<uint8Array.length; i+=2) {
      holder = uint8Array[i];
      uint8Array[i] = uint8Array[i+1];
      uint8Array[i+1] = holder;
    }
        
    var string = new TextDecoder().decode(uint8Array);
    return string;        
  }
  async getAlarmInfo() {
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_ALARM_INFO, 1);
    var uint8Array = new Uint8Array(arrayBuffer);
    return uint8Array[0];
  }
  async getInternalTemperature() {
    var arrayBuffer = await this.readHoldingRegisters(0x1, REG_TEMPERATURE, 2);
    var uint8Array = new Uint8Array(arrayBuffer);
    
    /* does not follow modbus standard so we have to swap bytes */
    for (var i=0, holder; i<uint8Array.length; i+=2) {
      holder = uint8Array[i];
      uint8Array[i] = uint8Array[i+1];
      uint8Array[i+1] = holder;
    }
    
    var dataView = new DataView(arrayBuffer);    
    return dataView.getFloat32(0, true);
  }  
  async setSetPoint(value) {
    var arrayBuffer = new ArrayBuffer(2);
    var dataView = new DataView(arrayBuffer);
    dataView.setUint16(0, value);
    await this.presetMultipleRegisters(0x1, REG_SETPOINT, arrayBuffer);
    return(true);
  }
  async wink() {
    var arrayBuffer = new ArrayBuffer(2);
    var dataView = new DataView(arrayBuffer);
    dataView.setUint16(0, 1);
    await this.presetMultipleRegisters(0x1, REG_WINK, arrayBuffer);    
  }
}


export default IQFlow;